export default __webpack_public_path__ + "static/media/logo-dark.324a1d9b.png";